(function($){
  var header = {
    init: function(){
      header.initHeader();
    },
    initHeader: function(){
      var $win = $(window);
      var $header = $(".header__content");
      var $winHeight = $win.height();
      var $btnBurger = $('.header__btn.m--burger');
      var $btnSearch = $('.header__btn.m--search');
      var $btnSearchClose = $('.header-search__btn.m--close');
      var $dropDown = $('.header__dropdown');
      var $dropDownDesk = $('.header__bottom');
      var $menuTopItem = $('.header__top .menu li');

      //sticky header
      $win.on('scroll', function() {
        window.requestAnimationFrame(function(){
          var $winScroll =  $(this).scrollTop();
          if ($winScroll > 100 && $winScroll < $winHeight && !$dropDown.hasClass('active')){
            $header.addClass("sticky");
          } else if ($winScroll > $winHeight){
            $header.addClass("sticky");
            $header.removeClass("invisible");
          } else if ($winScroll < $winHeight) {
            $header.removeClass("invisible");
            $header.removeClass("sticky");
          }
        });
      });

      //search popup
      $btnSearch.on('click', function() {
        $('.search-close.menu-item').show();
        $('body').addClass('searching');
        $('.header-search').stop(1,1).fadeIn(200);
      });
      $btnSearchClose.on('click', function() {
        $('.search-open.menu-item').show();
        $('body').removeClass('searching');
        $('.header-search').stop(1,1).fadeOut(200);
      });
      $(document).on('keyup', function(e) {
        if (e.key === "Escape" && $('body').hasClass('searching')) {
          $('.search-open.menu-item').show();
          $('body').removeClass('searching');
          $('.header-search').stop(1,1).fadeOut(200);
        }
      });

      //submenu handle
      if ($('.menu-item-btn').length == 0) {
        $menuTopItem.each(function() {
          var $this = $(this);
          var $link = $this.find('a');
          var $linkFirst = $link.first();
          var $subMenu = $this.find('.menu-sub-menu');
          var $menuItemBtn = $('<button type="button" class="menu-item-btn"></button>');
          var $menuBack = $('<li class="menu-title"><button type="button" class="menu-title__btn"><span>' + $link.html() + '</span></button></li>');

          $link.attr('title', $link.html());

          if ($subMenu.length) {
            $menuItemBtn.insertAfter($linkFirst);
            $subMenu.prepend($menuBack);
          }

        });
      }

      //burger button
      $btnBurger.on('click', function(){
        if ($win.width() >= 1024) {
          $(this).toggleClass('active');
          $dropDownDesk.toggleClass('active');
        } else {
          $(this).toggleClass('active');
          $dropDown.toggleClass('active');
        }
      });

      //menus toggle
      $('.menu-item-btn').on('click', function() {
        var $this = $(this);
        $this.next('.menu-sub-menu').addClass('slide');
      });

      $('.menu-title__btn').on('click', function() {
        var $this = $(this);
        $this.closest('.menu-sub-menu').removeClass('slide');
      });

      //pageUp button
      $win.on('scroll', function(){
        var $winTop = $(this).scrollTop();
        var $pageBottom = $(this).scrollTop() + $(this).height();
        var $footerTop = $('body').height() - $('.footer').height();
        var $footerTopCss = $win.height() - $('.footer').height();
        var $pageUp = $('.header__pageup');
        if ($winTop >= $(this).height() ){
          $('.header__pageup').css('display', 'block');
          if($pageBottom >= $footerTop ){
            $pageUp.addClass('m--sticky');
            $pageUp.css('top', $footerTopCss);
          } else {
            $pageUp.removeClass('m--sticky');
            $('.header__pageup').css('top', $(this).height() + 100);
          }
        } else {
          $('.header__pageup').css('display', 'none');
        }
      });

      //resize cleanup
      $win.on('resize', function() {
        $('.header .active').each(function() {
          $(this).removeClass('active');
        });
        $('.header .slide').each(function() {
          $(this).removeClass('slide');
        });
      });

    }
  };
  $(document).ready(header.init);
})(jQuery);
